import vzanAddress from './index.vue'
export default {
  install(Vue) {
    Vue.component('vzan-address', vzanAddress)
  }
}
